import axios from "axios";
import Consts from "./consts";

function apiGet(url, success = (resp) => {
    this.setState({
        error: "",
        status: resp.message !== undefined ? resp.message : "",
        loading: false,
    });
    return resp;
}, noApi = false, noErrorSet = false, onError = null) {
    axios.get(Consts.f("", ((window.VEREINfachtConfig || {}).verein_ID !== undefined ? "https://mein.vereinfacht.at" : "")) + (!noApi ? Consts.API_PREFIX : "") + url, {
        headers: {
            'Content-Type': 'application/json',
        }
    })
        .then(response => {
            if (response.data.status === "error") {
                this.setState({
                    error: response.data.message,
                    status: "",
                    loading: false,
                });

                onError && onError(response.data.message)

            } else {
                this.setState({
                    ...(noErrorSet ? {} : {error: ""}),
                    loading: false,
                });
                success(response.data)
            }

        })
        .catch((error) => {
            console.log("error", error);
            onError && onError(error)
            this.setState({
                error: error.message,
                status: "",
                loading: false,
            })


        });
}

function apiPost(url, data, success = (resp) => {
    this.setState({
        error: "",
        status: resp.message !== undefined ? resp.message : "",
        loading: false,
    })
}, noErrorSet = false, onError = null) {
    axios.post(Consts.API_PREFIX + url, data, {
        headers: {
            'Content-Type': 'application/json',
        }
    })
        .then(response => {
            if (response.data.status === "error") {
                onError && onError(response.data.message)
                console.log(onError)
                this.setState({
                    error: response.data.message,
                    status: "",
                    loading: false,
                })

            } else {
                this.setState({
                    ...(noErrorSet ? {} : {error: ""}),
                    loading: false,
                });
                success(response.data, response)
            }

        })
        .catch((error) => {
            console.log("error", error);
            onError && onError(error.message)
            this.setState({
                error: error.message,
                status: "",
                loading: false,
            })


        });
}

export {apiGet, apiPost}